import { render, staticRenderFns } from "./PcPostalCodeTextFieldReskinned.vue?vue&type=template&id=ccfd057c"
import script from "./PcPostalCodeTextFieldReskinned.vue?vue&type=script&lang=js"
export * from "./PcPostalCodeTextFieldReskinned.vue?vue&type=script&lang=js"
import style0 from "./PcPostalCodeTextFieldReskinned.vue?vue&type=style&index=0&id=ccfd057c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
